<ng-container *ngIf="employment">
  {{ employment.startDate | displayDbDate: "EEEEEE. dd.MM.yyyy" }} -
  {{ employment.endDate | displayDbDate: "EEEEEE. dd.MM.yyyy" }}
</ng-container>
